module.exports = __webpack_public_path__ + "img/rcyy.3d6ae868.png";